<!-- O player NÃO acompanha o tamanho configurado (singleVideoGrid): encolher os
     controles nativos deixa o vídeo ruim de usar. O tamanho é decisão de impressão e
     aparece na folha do PDF, não aqui. -->
<div class="video-frame">
    <video 
        [src]="item()?.value" 
        [attr.poster]="item()?.thumbUrl ?? null"
        controls
        [preload]="'metadata'"
        [controlsList]="'nodownload'"
        [disableRemotePlayback]="true">
    </video>

</div>

<!--
    Só na tela: esta prévia NÃO é a folha impressa (o PDF sai do painel com paged.js, que
    renderiza o HTML do pdf-renderer). O vídeo já toca; o que falta é a versão normalizada
    e, com ela, a miniatura e a duração.

    Fica ABAIXO do vídeo, não sobreposto: em cima de imagem escura o aviso sumia.
-->
@if (item()?.videoStatus)
{
    <div class="video-processing">
        <span class="video-processing-spinner" aria-hidden="true"></span>
        <span>{{ 'document.edit.videoCard.processing' | translate }}</span>
    </div>
}

@if (item()?.description)
{
    <p class="preview-doc-text description-video" [style.--item-size]="descriptionSize()" [style.--item-color]="descriptionColor()">
        <ra-viewer-text [content]="item()?.description" />
    </p>
}
